const lib={

    play:(audioContext,store,bufferindex,output,offsetin,offsetout,when)=>{

      if(bufferindex==null){
         return false
      }

        const startTime = (when != null && when >= audioContext.currentTime)
            ? when
            : audioContext.currentTime

        if (store.source) {
            const dyingSource = store.source
            const dyingProc   = store.sourceprocessor
            try { dyingSource.stop(startTime) } catch(e) {}
            const cleanupDelay = Math.max(0, (startTime - audioContext.currentTime) * 1000 + 120)
            setTimeout(() => {
                try { dyingProc.disconnect() }    catch(e) {}
                try { dyingSource.disconnect() }  catch(e) {}
            }, cleanupDelay)
            store.source = null
            store.sourceprocessor = null
        }

       store.source = audioContext.createBufferSource()
       store.sourceprocessor = audioContext.createScriptProcessor()

       if(store.reverse){
        store.source.buffer=store.revbuffers[bufferindex]
       }else{
        store.source.buffer=store.buffers[bufferindex]
       }

    const offin =(store.source.buffer.duration / 100) * Number(offsetin)
    const offout =(store.source.buffer.duration / 100) * Number(offsetout)
       store.source.playbackRate.value = store.pitcharray[parseInt(store.pitchknob.value)+100]
       store.source.connect(output);
       store.source.connect(store.sourceprocessor)
       store.sourceprocessor.connect(output)

        store.source.loop = store.sampleloop;
        if (store.sampleloop) {
           store.source.loopStart = offin
           store.source.loopEnd = offout
           store.source.start(startTime,offin)

        }else{
        store.source.start(startTime,offin,offout-offin)
       }

       store.sourceprocessor.onaudioprocess=()=>{
         store.source.playbackRate.value = store.pitcharray[parseInt(store.pitchknob.value)+100]
         store.source.loopStart = (store.source.buffer.duration / 100) * Number(offsetin)
         store.source.loopEnd = (store.source.buffer.duration / 100) * Number(offsetout)
         
       }
       return startTime
   
       }
       
}


module.exports=lib